<mat-dialog-content>
    <div class="description">
        <p>{{data.description}}</p>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Fechar</button>
</mat-dialog-actions>